export default function(callback: FrameRequestCallback): number {
    return requestAnimationFrame(callback);
}
